export default {"src":"/org/_next/static/media/chevron-right.99ba96d0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};